import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/expense/deleteaction";
import updateaction from "../../context/action/expense/updateaction";

const Editexpensemodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);

  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative my-2 sm:my-4 md:my-6 mx-auto w-full sm:w-2/3 md:w-1/2 lg:w-2/5">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="flex flex-col gap-4">
                    {/* Amount Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2 
                          ${error ? "text-red-500" : "text-gray-700"}`}
                      >
                        بڕی خەرجی
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error ? "border-red-500" : "border-gray-200"}`}
                        type="number"
                        onClick={(val)=>{val.target.select()}}
                        value={props.expense_amount}
                        onChange={(val) => props.setexpense_amount(val.target.value)}
                        onFocus={() => seterror(false)}
                      />
                    </div>

                    {/* Expense Type Select */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2 
                          ${error1 ? "text-red-500" : "text-gray-700"}`}
                      >
                        جۆری خەرجی
                      </label>
                      <select
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error1 ? "border-red-500" : "border-gray-200"}`}
                        value={props.expense_type_id}
                        onChange={(val) => {
                          props.setexpense_type_id(val.target.value);
                          seterror1(false);
                        }}
                      >
                        <option value="null">جۆری خەرجی هەڵبژێرە</option>
                        {initState.active_expense_type.map((lis) => (
                          <option key={lis.expense_type_id} value={lis.expense_type_id}>
                            {lis.expense_type_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Date Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2 
                          ${error2 ? "text-red-500" : "text-gray-700"}`}
                      >
                        بەرواری خەرجی
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error2 ? "border-red-500" : "border-gray-200"}`}
                        type="date"
                        value={props.expense_date}
                        onChange={(val) => props.setexpense_date(val.target.value)}
                        onFocus={() => seterror2(false)}
                      />
                    </div>

                    {/* Note Input */}
                    <div className="w-full">
                      <label className="block uppercase tracking-wide text-xs font-bold mb-2 text-gray-700">
                        تێبینی
                      </label>
                      <input
                        className="appearance-none block w-full bg-gray-50 
                          text-gray-700 border border-gray-200 rounded 
                          py-2 sm:py-3 px-3 sm:px-4 leading-tight 
                          transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500"
                        type="text"
                        onClick={(val)=>{val.target.select()}}
                        value={props.expense_note}
                        onChange={(val) => props.setexpense_note(val.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex flex-wrap sm:flex-nowrap items-center justify-end gap-2 p-3 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => {
                      if (window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟")) {
                        deleteaction(props.expense_id)(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => {
                      if (
                        props.expense_type_id == "null" ||
                        !props.expense_type_id
                      ) {
                        seterror1(true);
                        return false;
                      }
                      if (!props.expense_amount) {
                        seterror(true);
                        return false;
                      }
                      if (!props.expense_date) {
                        seterror2(true);
                        return false;
                      }
                      if (
                        window.confirm(
                          "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                        ) == true
                      ) {
                        updateaction(
                          props.expense_id,
                          props.expense_amount,
                          props.expense_type_id,
                          props.expense_date,
                          props.expense_note,
                          initState.token.id
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Editexpensemodal;
